import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/business/notice',
    component: Layout,
    redirect: '/business/notice/index',
    meta: {
      title: '公告管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'index',
        name: 'BusinessNoticeIndex',
        component: () => import('@/views/business/notice/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '公告管理'
        }
      }
    ]
  }
]

export default router
